class ReviewSystem {
    constructor() {
        this.reviews = [];
        this.filteredReviews = [];
        this.currentPage = 1;
        this.reviewsPerPage = 6;
        this.totalPages = 1;
        this.selectedRatings = new Set();
        this.searchQuery = '';
        this.init();
    }

    async init() {
        await this.loadReviews();
        this.filteredReviews = [...this.reviews];
        this.renderReviews();
        this.setupPagination();
        this.updateReviewStats();
        this.updateReviewCount();
        this.setupEventListeners();
    }

    async loadReviews() {
        // Use Shopify asset URLs if available
        const filesToTry = [];
        
        if (window.reviewUrls) {
            // In Shopify environment - use asset URLs
            filesToTry.push(window.reviewUrls.productSpecific);
            filesToTry.push(window.reviewUrls.default);
        } else {
            // Fallback for non-Shopify environment
            const productId = window.productId || 'default';
            filesToTry.push(`reviews.${productId}.json`);
            filesToTry.push('reviews.json');
        }

        let loaded = false;
        for (const fileUrl of filesToTry) {
            try {
                const response = await fetch(fileUrl);
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                this.reviews = await response.json();
                console.log(`Loaded ${this.reviews.length} reviews from ${fileUrl}`);
                loaded = true;
                break;
            } catch (error) {
                console.log(`Failed to load ${fileUrl}:`, error.message);
            }
        }

        if (!loaded) {
            console.log('Using sample reviews as fallback');
            this.reviews = this.getSampleReviews();
        }

        // Assign dates to reviews
        this.assignDatesToReviews();
        
        this.totalPages = Math.ceil(this.reviews.length / this.reviewsPerPage);
        
        // Expose total count globally and dispatch event
        window.totalReviewCount = this.reviews.length;
        window.dispatchEvent(new CustomEvent('reviewsLoaded', { 
            detail: { 
                totalCount: this.reviews.length,
                reviews: this.reviews 
            } 
        }));
    }

    getSampleReviews() {
        return [
            {
                customerName: "Tokiniaina",
                verified: true,
                rating: "5",
                date: new Date().toISOString(),
                comment: "Simple et rapide",
                image_url: "",
                answer: ""
            },
            {
                customerName: "Fred",
                verified: true,
                rating: "5",
                date: new Date().toISOString(),
                comment: "Vraiment parfait, rapide et très correct.\n\nJe recommande",
                image_url: "",
                answer: ""
            },
            {
                customerName: "Amiaud",
                verified: true,
                rating: "5",
                date: new Date().toISOString(),
                comment: "Les fond sont très vite débloqué ont reçois très vite notre tableau échéancier ainsi que tout les documents. L'application est très simple et bien expliqué. Merci",
                image_url: "",
                answer: ""
            },
            {
                customerName: "AURELIEN",
                verified: true,
                rating: "5",
                date: new Date().toISOString(),
                comment: "Facile, rapide, efficace.",
                image_url: "",
                answer: ""
            }
        ];
    }

    renderReviews() {
        const container = document.querySelector('.styles_wrapper__Fi9KX[data-reviews-list-start="true"]');
        if (!container) return;

        // Calculate start and end indices for current page
        const startIdx = (this.currentPage - 1) * this.reviewsPerPage;
        const endIdx = startIdx + this.reviewsPerPage;
        const pageReviews = this.filteredReviews.slice(startIdx, endIdx);

        // Clear existing reviews
        container.innerHTML = '';

        // Render each review
        pageReviews.forEach((review, index) => {
            const reviewElement = this.createReviewElement(review, startIdx + index);
            container.appendChild(reviewElement);
        });

        // Update pagination buttons
        this.updatePaginationButtons();
        
        // Update total pages based on filtered reviews
        this.totalPages = Math.ceil(this.filteredReviews.length / this.reviewsPerPage);
    }

    createReviewElement(review, index) {
        const wrapper = document.createElement('div');
        wrapper.className = 'styles_cardWrapper__g8amG styles_show__Z8n7u';
        
        const initials = this.getInitials(review.customerName);
        const avatarColor = this.getAvatarColor(index);
        const timeAgo = this.getTimeAgo(review.date);
        const reviewCount = Math.floor(Math.random() * 10) + 1;
        const reviewCountText = '${count} opinii'.replace('${count}', reviewCount);

        wrapper.innerHTML = `
            <article class="paper_paper__EGeEb paper_square__owXbO card_card__yyGgu card_noPadding__OOiac card_square___AZeg styles_reviewCard__Qwhpy" data-service-review-card-paper="true">
                <div>
                    <div class="styles_reviewCardInnerHeader__8Xqy8">
                        <aside class="styles_consumerInfoWrapper__6HN5O" aria-label="Informacje o ${review.customerName}">
                            <div class="styles_consumerDetailsWrapper__4eZod">
                                <div class="avatar_avatar__QtS0N ${avatarColor}" style="width:44px;min-width:44px;height:44px;min-height:44px" data-consumer-avatar="true">
                                    <span class="typography_heading-xs__osRhC typography_appearance-default__t8iAq typography_disableResponsiveSizing__z3EGy avatar_avatarName__2WZwR">${initials}</span>
                                </div>
                                <a href="#" rel="nofollow" name="consumer-profile" target="_self" class="link_internal__Eam_b link_wrapper__ahpyq styles_consumerDetails__POC79" data-consumer-profile-link="true">
                                    <span class="typography_heading-xs__osRhC typography_appearance-default__t8iAq styles_consumerName__xKr9c" data-consumer-name-typography="true">${review.customerName}</span>
                                    <div class="styles_consumerExtraDetails__NY6RP" data-consumer-reviews-count="${reviewCount}">
                                        <span class="typography_body-m__k2UI7 typography_appearance-subtle__PYOVM" data-consumer-country-typography="true">PL</span>
                                        <span class="typography_body-xs__IKE8N typography_appearance-subtle__PYOVM" data-lil-dot-typography="true">•</span>
                                        <span class="typography_body-m__k2UI7 typography_appearance-subtle__PYOVM" data-consumer-reviews-count-typography="true">
                                            ${reviewCountText}
                                        </span>
                                    </div>
                                </a>
                            </div>
                        </aside>
                        <div class="typography_body-m__k2UI7 typography_appearance-subtle__PYOVM">
                            <time datetime="${review.date || new Date().toISOString()}" class="" data-service-review-date-time-ago="true">${timeAgo}</time>
                        </div>
                    </div>
                    <section class="styles_reviewContentwrapper__K2aRu" aria-disabled="false">
                        <div class="styles_reviewHeader__DzoAZ" data-service-review-rating="${review.rating}">
                            <div class="star-rating_starRating__sdbkn star-rating_medium__Oj7C9">
                                <img alt="Oceniono na ${rating} z 5 gwiazdek" src="https://cdn.trustpilot.net/brand-assets/4.1.0/stars/stars-${review.rating}.svg" onerror="this.src='https://cdn.trustpilot.net/brand-assets/4.1.0/stars/stars-5.svg'">
                            </div>
                            ${review.verified ? `
                            <div class="styles_reviewLabels__XRzot styles_reviewLabels__ZmJZW">
                                <div class="styles_reviewLabel__Ea8JW">
                                    <span>
                                        <span>
                                            <div class="typography_body-m__k2UI7 typography_appearance-subtle__PYOVM styles_detailsIcon__n1OXF" data-review-label-tooltip-trigger-typography="true">
                                                <span role="button" tabindex="0">
                                                    <svg viewBox="0 0 16 16" fill="inherit" class="icon_icon__RdICC icon_appearance-inherit__MeZek" xmlns="http://www.w3.org/2000/svg" width="14px" height="14px">
                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M14 4.62 6.233 12 2 8.16l.658-.633 3.56 3.228L13.326 4l.673.62Z"></path>
                                                    </svg>
                                                    <span>Zweryfikowane</span>
                                                </span>
                                            </div>
                                        </span>
                                    </span>
                                </div>
                            </div>
                            ` : ''}
                        </div>
                        <div class="styles_reviewContent__tuXiN" aria-hidden="false" data-review-content="true">
                            <a href="#" rel="nofollow" target="_self" class="link_internal__Eam_b typography_appearance-inherit__YnCNb link_link__jBdLV link_notUnderlined__y4Qsc" data-review-title-typography="true">
                                <h2 class="typography_heading-xs__osRhC typography_appearance-default__t8iAq" data-service-review-title-typography="true">${this.getReviewTitle(review.comment)}</h2>
                            </a>
                            <p class="typography_body-l__v5JLj typography_appearance-default__t8iAq" data-service-review-text-typography="true">${review.comment}</p>
                            <p class="typography_body-m__k2UI7 typography_appearance-default__t8iAq" data-service-review-date-of-experience-typography="true">
                                <b class="typography_body-m__k2UI7 typography_appearance-default__t8iAq typography_weight-heavy__rS52U" weight="heavy">
                                    Data doświadczenia:
                                </b>
                                <span class="typography_body-m__k2UI7 typography_appearance-subtle__PYOVM">${this.formatDate(review.date)}</span>
                            </p>
                        </div>
                    </section>
                    <div class="styles_wrapper___luvQ styles_actionsWrapper__PJqVW">
                        <button class="buttons_actionButtons__SZCAW buttons_button__ECb04 button_button__EM6gX button_appearance-link__kao21" name="find-useful" type="button" data-find-useful-button="true">
                            <span class="typography_body-l__v5JLj typography_appearance-subtle__PYOVM link_link__jBdLV link_notUnderlined__y4Qsc">
                                <svg viewBox="0 0 16 16" fill="currentColor" class="icon_icon__RdICC" xmlns="http://www.w3.org/2000/svg" width="14px" height="14px">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.94.94A1.5 1.5 0 0 1 10.5 2a20.774 20.774 0 0 1-.384 4H14.5A1.5 1.5 0 0 1 16 7.5v.066l-1.845 6.9-.094.095A1.5 1.5 0 0 1 13 15H9c-.32 0-.685-.078-1.038-.174-.357-.097-.743-.226-1.112-.349l-.008-.003c-.378-.126-.74-.246-1.067-.335C5.44 14.047 5.18 14 5 14v.941l-5 .625V6h5v.788c.913-.4 1.524-1.357 1.926-2.418A10.169 10.169 0 0 0 7.5 1.973 1.5 1.5 0 0 1 7.94.939ZM8 2l.498.045v.006l-.002.013a4.507 4.507 0 0 1-.026.217 11.166 11.166 0 0 1-.609 2.443C7.396 5.951 6.541 7.404 5 7.851V13c.32 0 .685.078 1.038.174.357.097.743.226 1.112.349l.008.003c.378.126.74.246 1.067.335.335.092.594.139.775.139h4a.5.5 0 0 0 .265-.076l1.732-6.479A.5.5 0 0 0 14.5 7H8.874l.138-.61c.326-1.44.49-2.913.488-4.39a.5.5 0 0 0-1 0v.023l-.002.022L8 2ZM4 7H1v7.434l3-.375V7Zm-1.5 5.75a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-.75-.25a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0Z"></path>
                                </svg>
                                <span class="typography_body-m__k2UI7 typography_appearance-inherit__YnCNb styles_usefulLabel__VcnL3">Przydatne</span>
                            </span>
                        </button>
                    </div>
                </div>
            </article>
        `;

        return wrapper;
    }

    getInitials(name) {
        const parts = name.split(' ');
        if (parts.length >= 2) {
            return parts[0][0].toUpperCase() + parts[parts.length - 1][0].toUpperCase();
        }
        return name.substring(0, 2).toUpperCase();
    }

    getAvatarColor(index) {
        const colors = [
            'avatar_orange__cIcPd',
            'avatar_yellow__4LW3g',
            'avatar_pink__662MO',
            'avatar_green__CI6et',
            'avatar_blue__3pvAa'
        ];
        return colors[index % colors.length];
    }

    getTimeAgo(dateString) {
        if (!dateString) {
            return 'Kilka godzin temu';
        }
        const date = new Date(dateString);
        const now = new Date();
        const diffMs = now - date;
        const diffMinutes = Math.floor(diffMs / (1000 * 60));
        const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
        const diffDays = Math.floor(diffHours / 24);
        const diffWeeks = Math.floor(diffDays / 7);
        
        // More granular time displays
        if (diffMinutes < 60) {
            if (diffMinutes < 5) return 'Kilka minut temu';
            return '${diffMinutes} minut temu'.replace('${diffMinutes}', diffMinutes);
        }
        
        if (diffHours < 24) {
            if (diffHours === 1) return '1 godzinę temu';
            return '${diffHours} godzin temu'.replace('${diffHours}', diffHours);
        }
        
        if (diffDays === 1) return 'Wczoraj';
        if (diffDays < 7) return '${diffDays} dni temu'.replace('${diffDays}', diffDays);
        if (diffDays < 30) return '${diffWeeks} tygodni temu'.replace('${diffWeeks}', diffWeeks);
        
        return this.formatDate(dateString);
    }

    formatDate(dateString) {
        if (!dateString) {
            return 'Data nieznana';
        }
        const date = new Date(dateString);
        const months = ['Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec', 'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień'];
        return `${date.getDate()} ${months[date.getMonth()]} ${date.getFullYear()}`;
    }

    getReviewTitle(comment) {
        // Extract first few words as title
        const words = comment.split(' ').slice(0, 4);
        return words.join(' ') + (comment.split(' ').length > 4 ? '...' : '');
    }

    assignDatesToReviews() {
        if (this.reviews.length < 2) {
            console.log("Not enough reviews to randomize dates.");
            return;
        }

        // Initialize random seed for consistent results
        const rng = new Math.seedrandom('trustpilot-reviews-' + window.productId);
        
        const today = new Date();
        const yesterday = new Date(today);
        yesterday.setDate(today.getDate() - 1);

        // Separate reviews into categories based on text and rating
        const highRatedWithText = [];     // 4-5 stars with text
        const lowRatedWithText = [];      // 1-3 stars with text
        const highRatedNoText = [];       // 4-5 stars without text
        const lowRatedNoText = [];        // 1-3 stars without text

        // Distribute reviews into categories
        this.reviews.forEach(review => {
            const rating = parseInt(review.rating) || 5;
            const hasText = review.comment && review.comment.trim();
            
            if (hasText) {
                if (rating >= 4) {
                    highRatedWithText.push(review);
                } else {
                    lowRatedWithText.push(review);
                }
            } else {
                if (rating >= 4) {
                    highRatedNoText.push(review);
                } else {
                    lowRatedNoText.push(review);
                }
            }
        });

        // Shuffle all arrays using seeded random
        this.shuffleArray(highRatedWithText, rng);
        this.shuffleArray(lowRatedWithText, rng);
        this.shuffleArray(highRatedNoText, rng);
        this.shuffleArray(lowRatedNoText, rng);

        // Reserve reviews for today and yesterday - prioritize high-rated reviews with text
        const todaysReviews = [];
        const yesterdaysReviews = [];

        // Priority order: 1) High-rated with text, 2) High-rated no text, 3) Low-rated with text, 4) Low-rated no text
        
        // Fill today's reviews (7 total)
        while (highRatedWithText.length > 0 && todaysReviews.length < 7) {
            todaysReviews.push(highRatedWithText.shift());
        }
        while (highRatedNoText.length > 0 && todaysReviews.length < 7) {
            todaysReviews.push(highRatedNoText.shift());
        }
        while (lowRatedWithText.length > 0 && todaysReviews.length < 7) {
            todaysReviews.push(lowRatedWithText.shift());
        }
        while (lowRatedNoText.length > 0 && todaysReviews.length < 7) {
            todaysReviews.push(lowRatedNoText.shift());
        }

        // Fill yesterday's reviews (8 total)
        while (highRatedWithText.length > 0 && yesterdaysReviews.length < 8) {
            yesterdaysReviews.push(highRatedWithText.shift());
        }
        while (highRatedNoText.length > 0 && yesterdaysReviews.length < 8) {
            yesterdaysReviews.push(highRatedNoText.shift());
        }
        while (lowRatedWithText.length > 0 && yesterdaysReviews.length < 8) {
            yesterdaysReviews.push(lowRatedWithText.shift());
        }
        while (lowRatedNoText.length > 0 && yesterdaysReviews.length < 8) {
            yesterdaysReviews.push(lowRatedNoText.shift());
        }

        // Assign today's and yesterday's dates with random times
        todaysReviews.forEach((review, index) => {
            const reviewDate = new Date(today);
            const currentHour = new Date().getHours();
            
            // For today's reviews, ensure they're at least 2 hours old
            // Spread them from morning until 2 hours ago
            const maxHour = Math.max(8, currentHour - 2); // At least 2 hours ago, but not before 8 AM
            const hour = Math.floor(rng() * (maxHour - 8)) + 8; // Between 8 AM and 2 hours ago
            const minute = Math.floor(rng() * 60);
            const second = Math.floor(rng() * 60);
            reviewDate.setHours(hour, minute, second);
            review.date = reviewDate.toISOString();
        });
        yesterdaysReviews.forEach((review, index) => {
            const reviewDate = new Date(yesterday);
            // Spread reviews throughout the day
            const hour = Math.floor(rng() * 15) + 8; // 8 AM to 10 PM
            const minute = Math.floor(rng() * 60);
            const second = Math.floor(rng() * 60);
            reviewDate.setHours(hour, minute, second);
            review.date = reviewDate.toISOString();
        });

        // Calculate how many reviews we need for the first 3 pages (6 reviews per page = 18 total)
        // We already have 15 (7 today + 8 yesterday), need 3 more for first 3 pages
        const reviewsNeededForFirst3Pages = Math.max(0, (3 * this.reviewsPerPage) - todaysReviews.length - yesterdaysReviews.length);
        
        // Date ranges for remaining reviews
        const oneWeekAgo = new Date(yesterday);
        oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
        
        const oneMonthAgo = new Date(yesterday);
        oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
        
        const threeMonthsAgo = new Date(yesterday);
        threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);
        
        const sixMonthsAgo = new Date(yesterday);
        sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);
        
        const oneYearAgo = new Date(yesterday);
        oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
        
        // Collect reviews for the week after yesterday (to fill first 3 pages)
        const weekAfterReviews = [];
        
        // Fill remaining slots for first 3 pages with high-rated reviews
        while (highRatedWithText.length > 0 && weekAfterReviews.length < reviewsNeededForFirst3Pages) {
            const review = highRatedWithText.shift();
            review.date = this.generateRandomDate(oneWeekAgo, yesterday, rng);
            weekAfterReviews.push(review);
        }
        while (highRatedNoText.length > 0 && weekAfterReviews.length < reviewsNeededForFirst3Pages) {
            const review = highRatedNoText.shift();
            review.date = this.generateRandomDate(oneWeekAgo, yesterday, rng);
            weekAfterReviews.push(review);
        }
        
        // Assign dates to remaining high-rated reviews (1 week to 3 months ago)
        highRatedWithText.forEach(review => {
            review.date = this.generateRandomDate(threeMonthsAgo, oneWeekAgo, rng);
        });
        
        highRatedNoText.forEach(review => {
            review.date = this.generateRandomDate(threeMonthsAgo, oneWeekAgo, rng);
        });
        
        // Assign dates to low-rated reviews (3 months to 1 year ago)
        lowRatedWithText.forEach(review => {
            review.date = this.generateRandomDate(oneYearAgo, threeMonthsAgo, rng);
        });
        
        lowRatedNoText.forEach(review => {
            review.date = this.generateRandomDate(oneYearAgo, sixMonthsAgo, rng);
        });

        // Combine all reviews and sort by date (newest first)
        this.reviews = [
            ...todaysReviews, 
            ...yesterdaysReviews, 
            ...weekAfterReviews,
            ...highRatedWithText, 
            ...highRatedNoText,
            ...lowRatedWithText,
            ...lowRatedNoText
        ];
        this.reviews.sort((a, b) => new Date(b.date) - new Date(a.date));
    }

    shuffleArray(array, rng) {
        for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(rng() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]];
        }
    }

    generateRandomDate(startDate, endDate, rng) {
        const start = startDate.getTime();
        const end = endDate.getTime();
        const randomTime = start + rng() * (end - start);
        const randomDate = new Date(randomTime);
        
        // Add random time during the day (between 8 AM and 11 PM)
        const hour = Math.floor(rng() * 15) + 8; // 8-22 (8 AM to 10 PM)
        const minute = Math.floor(rng() * 60);
        const second = Math.floor(rng() * 60);
        
        randomDate.setHours(hour, minute, second);
        
        return randomDate.toISOString();
    }


    setupPagination() {
        // Add pagination controls after the reviews
        const reviewsSection = document.querySelector('.styles_reviewListContainer__2bg_p');
        if (!reviewsSection) return;

        let paginationDiv = document.getElementById('review-pagination');
        if (!paginationDiv) {
            paginationDiv = document.createElement('div');
            paginationDiv.id = 'review-pagination';
            paginationDiv.className = 'review-pagination';
            reviewsSection.appendChild(paginationDiv);
        }

        paginationDiv.innerHTML = `
            <div class="pagination-controls">
                <button id="prev-page" class="button_button__EM6gX button_m__J8iy5 button_appearance-outline__K_fYw" ${this.currentPage === 1 ? 'disabled' : ''}>
                    <span class="typography_heading-xxs__UmE9o typography_appearance-inherit__YnCNb typography_disableResponsiveSizing__z3EGy button_buttonText__uWBzs">
                        Poprzednia
                    </span>
                </button>
                <span class="pagination-info typography_body-m__k2UI7 typography_appearance-default__t8iAq">
                    <!-- Will be updated by updatePaginationButtons -->
                </span>
                <button id="next-page" class="button_button__EM6gX button_m__J8iy5 button_appearance-outline__K_fYw" ${this.currentPage === this.totalPages ? 'disabled' : ''}>
                    <span class="typography_heading-xxs__UmE9o typography_appearance-inherit__YnCNb typography_disableResponsiveSizing__z3EGy button_buttonText__uWBzs">
                        Następna
                    </span>
                </button>
            </div>
        `;

        // Add event listeners
        document.getElementById('prev-page')?.addEventListener('click', () => this.previousPage());
        document.getElementById('next-page')?.addEventListener('click', () => this.nextPage());
        
        // Update the pagination text
        this.updatePaginationButtons();
    }

    updatePaginationButtons() {
        const prevBtn = document.getElementById('prev-page');
        const nextBtn = document.getElementById('next-page');
        const pageInfo = document.querySelector('.pagination-info');

        if (prevBtn) prevBtn.disabled = this.currentPage === 1;
        if (nextBtn) nextBtn.disabled = this.currentPage === this.totalPages;
        if (pageInfo) pageInfo.textContent = 'Strona ${currentPage} z ${totalPages}'.replace('${currentPage}', this.currentPage).replace('${totalPages}', this.totalPages);
    }

    previousPage() {
        if (this.currentPage > 1) {
            this.currentPage--;
            this.renderReviews();
            this.scrollToReviews();
        }
    }

    nextPage() {
        if (this.currentPage < this.totalPages) {
            this.currentPage++;
            this.renderReviews();
            this.scrollToReviews();
        }
    }

    scrollToReviews() {
        const reviewsSection = document.querySelector('.styles_reviewListContainer__2bg_p');
        if (reviewsSection) {
            reviewsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    updateReviewStats() {
        // Update total review count
        const reviewCountElement = document.querySelector('[data-reviews-count-typography="true"]');
        if (reviewCountElement) {
            reviewCountElement.textContent = 'Łącznie: ${count}'.replace('${count}', this.reviews.length);
        }

        // Calculate and update rating distribution
        this.updateRatingDistribution();
    }

    updateReviewCount() {
        // Update the review count in the Trustpilot snippet
        const reviewCountElement = document.getElementById('reviews-total');
        if (reviewCountElement) {
            reviewCountElement.textContent = this.reviews.length.toLocaleString();
        }
    }

    updateRatingDistribution() {
        const ratingCounts = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 };
        
        this.reviews.forEach(review => {
            const rating = parseInt(review.rating) || 5;
            if (rating >= 1 && rating <= 5) {
                ratingCounts[rating]++;
            }
        });

        const total = this.reviews.length;

        // Update rating bars - iterate from 5 to 1
        [5, 4, 3, 2, 1].forEach(rating => {
            const percentage = total > 0 ? Math.round((ratingCounts[rating] / total) * 100) : 0;
            const ratingName = rating === 5 ? 'five' : rating === 4 ? 'four' : rating === 3 ? 'three' : rating === 2 ? 'two' : 'one';
            const label = document.querySelector(`[data-star-rating="${ratingName}"]`);
            
            if (label) {
                // Update percentage text
                const percentageElement = label.querySelector('[data-rating-distribution-row-percentage-typography="true"]');
                if (percentageElement) {
                    percentageElement.innerHTML = percentage < 1 && percentage > 0 ? '&lt;1&nbsp;%' : `${percentage}&nbsp;%`;
                }

                // Update bar width
                const barValue = label.querySelector('.styles_barValue__X_IuW');
                if (barValue) {
                    barValue.style.width = `${Math.max(percentage, 2)}%`;
                }

                // Update title
                label.title = '${count} z ${total} opinii'
                    .replace('${count}', ratingCounts[rating])
                    .replace('${total}', total);
            }
        });

        // Update average rating
        const avgRating = total > 0 ? 
            (Object.entries(ratingCounts).reduce((sum, [rating, count]) => sum + (parseInt(rating) * count), 0) / total).toFixed(1) : 
            '0.0';
        
        const avgRatingElement = document.querySelector('.typography_display-m__t_jem');
        if (avgRatingElement) {
            avgRatingElement.textContent = avgRating.replace('.', ',');
        }
    }

    setupEventListeners() {
        // Star rating filters
        const starCheckboxes = document.querySelectorAll('.styles_row__4BwV6 input[type="checkbox"]');
        starCheckboxes.forEach(checkbox => {
            checkbox.addEventListener('change', (e) => {
                const label = e.target.closest('label');
                const rating = label.getAttribute('data-star-rating');
                const ratingNum = rating === 'five' ? 5 : rating === 'four' ? 4 : rating === 'three' ? 3 : rating === 'two' ? 2 : 1;
                
                if (e.target.checked) {
                    this.selectedRatings.add(ratingNum);
                    label.setAttribute('data-selected', 'true');
                } else {
                    this.selectedRatings.delete(ratingNum);
                    label.setAttribute('data-selected', 'false');
                }
                
                // Update parent container attribute
                const container = document.querySelector('.styles_container__7TW3E');
                if (container) {
                    container.setAttribute('data-some-selected', this.selectedRatings.size > 0 ? 'true' : 'false');
                }
                
                this.applyFilters();
            });
        });

        // Search input
        const searchInput = document.querySelector('[data-search-reviews-input="true"]');
        if (searchInput) {
            searchInput.addEventListener('input', (e) => {
                this.searchQuery = e.target.value.toLowerCase();
                this.applyFilters();
            });
        }

        // Write review button
        const writeReviewLink = document.querySelector('[data-review-company-link-typography="true"]');
        if (writeReviewLink) {
            writeReviewLink.addEventListener('click', (e) => {
                e.preventDefault();
                this.showReviewModal();
            });
        }

        // Modal event listeners
        this.setupModalEventListeners();

    }

    applyFilters() {
        // Start with all reviews
        let filtered = [...this.reviews];

        // Apply rating filter
        if (this.selectedRatings.size > 0) {
            filtered = filtered.filter(review => {
                const rating = parseInt(review.rating);
                return this.selectedRatings.has(rating);
            });
        }

        // Apply search filter
        if (this.searchQuery) {
            filtered = filtered.filter(review => {
                return review.comment.toLowerCase().includes(this.searchQuery) ||
                       review.customerName.toLowerCase().includes(this.searchQuery);
            });
        }

        // Update filtered reviews and reset to page 1
        this.filteredReviews = filtered;
        this.currentPage = 1;
        this.totalPages = Math.ceil(this.filteredReviews.length / this.reviewsPerPage);

        // Re-render
        this.renderReviews();
        this.setupPagination();
        
        // Update review count
        const reviewCountElement = document.querySelector('[data-reviews-count-typography="true"]');
        if (reviewCountElement) {
            const text = this.selectedRatings.size > 0 || this.searchQuery ? 
                'Filtrowane: ${count}'.replace('${count}', this.filteredReviews.length) : 
                'Łącznie: ${count}'.replace('${count}', this.reviews.length);
            reviewCountElement.textContent = text;
        }
    }

    setupModalEventListeners() {
        const modal = document.getElementById('reviewModal');
        const closeBtn = modal.querySelector('.review-modal-close');
        const overlay = modal.querySelector('.review-modal-overlay');
        const form = document.getElementById('reviewForm');
        const stars = modal.querySelectorAll('.star');
        const ratingInput = document.getElementById('rating');
        const closeThanksBtn = modal.querySelector('.close-thank-you');

        // Close button
        closeBtn.addEventListener('click', () => this.closeReviewModal());
        
        // Overlay click
        overlay.addEventListener('click', () => this.closeReviewModal());

        // Close thank you button
        closeThanksBtn.addEventListener('click', () => this.closeReviewModal());

        // Star rating
        stars.forEach(star => {
            star.addEventListener('click', () => {
                const rating = star.getAttribute('data-rating');
                ratingInput.value = rating;
                this.updateStarDisplay(rating);
            });

            star.addEventListener('mouseenter', () => {
                const rating = star.getAttribute('data-rating');
                this.updateStarDisplay(rating, true);
            });
        });

        // Reset stars on mouse leave
        const starContainer = modal.querySelector('.star-rating-input');
        starContainer.addEventListener('mouseleave', () => {
            this.updateStarDisplay(ratingInput.value);
        });

        // Form submission
        form.addEventListener('submit', (e) => {
            e.preventDefault();
            this.handleReviewSubmission();
        });
    }

    showReviewModal() {
        const modal = document.getElementById('reviewModal');
        modal.style.display = 'flex';
        document.body.style.overflow = 'hidden';
        
        // Reset form
        document.getElementById('reviewForm').reset();
        document.getElementById('rating').value = '5';
        this.updateStarDisplay(5);
        
        // Hide thank you message if shown
        document.getElementById('reviewForm').style.display = 'block';
        document.getElementById('thankYouMessage').style.display = 'none';
    }

    closeReviewModal() {
        const modal = document.getElementById('reviewModal');
        modal.style.display = 'none';
        document.body.style.overflow = '';
    }

    updateStarDisplay(rating, isHover = false) {
        const stars = document.querySelectorAll('.star');
        stars.forEach((star, index) => {
            if (index < rating) {
                star.classList.add(isHover ? 'active' : 'filled');
                if (!isHover) star.classList.remove('active');
            } else {
                star.classList.remove('filled', 'active');
            }
        });
    }

    handleReviewSubmission() {
        const form = document.getElementById('reviewForm');
        const formData = new FormData(form);
        
        // Get form values
        const reviewData = {
            customerName: formData.get('firstName') + (formData.get('lastName') ? ' ' + formData.get('lastName') : ''),
            email: formData.get('email'),
            title: formData.get('reviewTitle'),
            comment: formData.get('reviewText'),
            rating: formData.get('rating'),
            date: new Date().toISOString(),
            verified: false
        };

        // Log the review (in real app, this would be sent to server)
        console.log('New review submitted:', reviewData);

        // Add to reviews array (for demo purposes)
        this.reviews.unshift({
            customerName: reviewData.customerName,
            verified: false,
            rating: reviewData.rating,
            date: reviewData.date,
            comment: reviewData.comment,
            image_url: "",
            answer: ""
        });

        // Show thank you message
        document.getElementById('reviewForm').style.display = 'none';
        document.getElementById('thankYouMessage').style.display = 'block';

        // Refresh the reviews display
        this.filteredReviews = [...this.reviews];
        this.currentPage = 1;
        this.applyFilters();
        this.updateReviewStats();
    }

}

// CSS for pagination and modal
const style = document.createElement('style');
style.textContent = `
    .review-pagination {
        margin-top: 2rem;
        margin-bottom: 2rem;
    }

    .pagination-controls {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 1rem;
    }

    .pagination-info {
        padding: 0 1rem;
    }

    #prev-page:disabled,
    #next-page:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }

    /* Modal Styles */
    .review-modal {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 10000;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .review-modal-overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
    }

    .review-modal-content {
        position: relative;
        background: white;
        border-radius: 12px;
        width: 90%;
        max-width: 600px;
        max-height: 90vh;
        overflow-y: auto;
        box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
    }

    .review-modal-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 24px 24px 0;
    }

    .review-modal-close {
        background: none;
        border: none;
        cursor: pointer;
        padding: 8px;
        color: #6C6C85;
        transition: color 0.2s;
    }

    .review-modal-close:hover {
        color: #000;
    }

    .review-modal-form {
        padding: 24px;
    }

    .form-group {
        margin-bottom: 20px;
    }

    .form-group label {
        display: block;
        margin-bottom: 8px;
        color: #191919;
    }

    .form-group .required {
        color: #E94F2E;
    }

    .form-group .optional {
        color: #6C6C85;
        font-size: 14px;
    }

    .form-group input,
    .form-group textarea {
        width: 100%;
        padding: 12px 16px;
        border: 1px solid #E0E0E0;
        border-radius: 8px;
        font-size: 16px;
        transition: border-color 0.2s;
    }

    .form-group input:focus,
    .form-group textarea:focus {
        outline: none;
        border-color: #00B67A;
    }

    .form-group textarea {
        resize: vertical;
        min-height: 100px;
    }

    .star-rating-input {
        display: flex;
        gap: 8px;
        font-size: 32px;
    }

    .star {
        cursor: pointer;
        color: #E0E0E0;
        transition: color 0.2s;
        user-select: none;
    }

    .star:hover,
    .star.active {
        color: #00B67A;
    }

    .star.filled {
        color: #00B67A;
    }

    .review-submit-button {
        width: 100%;
        background: #00B67A;
        color: white;
        border: none;
        padding: 16px 24px;
        border-radius: 8px;
        font-size: 16px;
        font-weight: 600;
        cursor: pointer;
        transition: background 0.2s;
    }

    .review-submit-button:hover {
        background: #00A66E;
    }

    .thank-you-message {
        text-align: center;
        padding: 48px 24px;
    }

    .thank-you-message svg {
        margin-bottom: 24px;
    }

    .thank-you-message h3 {
        margin-bottom: 16px;
    }

    .thank-you-message p {
        margin-bottom: 32px;
        color: #6C6C85;
    }

    .close-thank-you {
        background: #00B67A;
        color: white;
        border: none;
        padding: 12px 24px;
        border-radius: 8px;
        cursor: pointer;
        transition: background 0.2s;
    }

    .close-thank-you:hover {
        background: #00A66E;
    }
`;
document.head.appendChild(style);

// Initialize the review system when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        window.reviewSystemInstance = new ReviewSystem();
    });
} else {
    window.reviewSystemInstance = new ReviewSystem();
}